module.exports = __webpack_public_path__ + "static/media/calendar.7629ffee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MobileApp/calendar.svg
// module id = 983
// module chunks = 0